import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account } from "model";
import TASPositivePayAddChecksPage, { getDefaultData } from "components/pages/TASPositivePayAddChecksPage";
import TASPositivePayCheckForm from "components/pages/TASPositivePayAddChecksPage/classes/TASPositivePayCheckForm";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @name CapturePositivePayAddACheckPPAddCheckCheckAdded
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Add a Check" capture group.
 */
export default function CapturePositivePayAddACheckPPAddCheckCheckAdded(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    const defaultData = getDefaultData();
    let checkForms = defaultData.checkForms;
    const account = checkForms[0].account;
    checkForms[0].checkNumber = "1040";
    checkForms[0].amount = "10.00";
    checkForms[0].payee = "John Sample";

    const newCheckForm = TASPositivePayCheckForm.init({ id: "1", account: account });
    defaultData.checkForms = [ ...checkForms, newCheckForm];

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "checkForms" ], defaultData.checkForms)
    .submit();

    return <TASPositivePayAddChecksPage data={ data } />;
}